var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsvDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9950_3904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 7.95719V36C34.9998 38.2091 33.209 40 30.9998 40H9C6.79086 40 5 38.2091 5 36V4C5 1.79086 6.79086 0 9 0H26.3367L34.9998 7.95719Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9950_3904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 7.95719H27.3367C26.7844 7.95719 26.3367 7.50947 26.3367 6.95719V0L34.9998 7.95719Z",
    fill: "#F2F4F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.8136 33.832C10.8136 33.208 10.9486 32.653 11.2186 32.167C11.4886 31.675 11.8636 31.294 12.3436 31.024C12.8296 30.748 13.3786 30.61 13.9906 30.61C14.7406 30.61 15.3826 30.808 15.9166 31.204C16.4506 31.6 16.8076 32.14 16.9876 32.824H15.2956C15.1696 32.56 14.9896 32.359 14.7556 32.221C14.5276 32.083 14.2666 32.014 13.9726 32.014C13.4986 32.014 13.1146 32.179 12.8206 32.509C12.5266 32.839 12.3796 33.28 12.3796 33.832C12.3796 34.384 12.5266 34.825 12.8206 35.155C13.1146 35.485 13.4986 35.65 13.9726 35.65C14.2666 35.65 14.5276 35.581 14.7556 35.443C14.9896 35.305 15.1696 35.104 15.2956 34.84H16.9876C16.8076 35.524 16.4506 36.064 15.9166 36.46C15.3826 36.85 14.7406 37.045 13.9906 37.045C13.3786 37.045 12.8296 36.91 12.3436 36.64C11.8636 36.364 11.4886 35.983 11.2186 35.497C10.9486 35.011 10.8136 34.456 10.8136 33.832ZM20.2161 37.063C19.7541 37.063 19.3401 36.988 18.9741 36.838C18.6081 36.688 18.3141 36.466 18.0921 36.172C17.8761 35.878 17.7621 35.524 17.7501 35.11H19.3881C19.4121 35.344 19.4931 35.524 19.6311 35.65C19.7691 35.77 19.9491 35.83 20.1711 35.83C20.3991 35.83 20.5791 35.779 20.7111 35.677C20.8431 35.569 20.9091 35.422 20.9091 35.236C20.9091 35.08 20.8551 34.951 20.7471 34.849C20.6451 34.747 20.5161 34.663 20.3601 34.597C20.2101 34.531 19.9941 34.456 19.7121 34.372C19.3041 34.246 18.9711 34.12 18.7131 33.994C18.4551 33.868 18.2331 33.682 18.0471 33.436C17.8611 33.19 17.7681 32.869 17.7681 32.473C17.7681 31.885 17.9811 31.426 18.4071 31.096C18.8331 30.76 19.3881 30.592 20.0721 30.592C20.7681 30.592 21.3291 30.76 21.7551 31.096C22.1811 31.426 22.4091 31.888 22.4391 32.482H20.7741C20.7621 32.278 20.6871 32.119 20.5491 32.005C20.4111 31.885 20.2341 31.825 20.0181 31.825C19.8321 31.825 19.6821 31.876 19.5681 31.978C19.4541 32.074 19.3971 32.215 19.3971 32.401C19.3971 32.605 19.4931 32.764 19.6851 32.878C19.8771 32.992 20.1771 33.115 20.5851 33.247C20.9931 33.385 21.3231 33.517 21.5751 33.643C21.8331 33.769 22.0551 33.952 22.2411 34.192C22.4271 34.432 22.5201 34.741 22.5201 35.119C22.5201 35.479 22.4271 35.806 22.2411 36.1C22.0611 36.394 21.7971 36.628 21.4491 36.802C21.1011 36.976 20.6901 37.063 20.2161 37.063ZM29.3982 30.682L27.1572 37H25.2312L22.9902 30.682H24.6282L26.1942 35.452L27.7692 30.682H29.3982Z",
    fill: "#171717",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20.5V23.8333C27.5 24.2754 27.3244 24.6993 27.0118 25.0118C26.6993 25.3244 26.2754 25.5 25.8333 25.5H14.1667C13.7246 25.5 13.3007 25.3244 12.9882 25.0118C12.6756 24.6993 12.5 24.2754 12.5 23.8333V20.5M15.8333 16.3333L20 20.5M20 20.5L24.1667 16.3333M20 20.5V10.5",
    stroke: "#171717",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9950_3904",
    x: 23.3367,
    y: -1,
    width: 12.6631,
    height: 11.9572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9950_3904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9950_3904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9950_3904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvDownload);
export default __webpack_public_path__ + "static/media/csv-download.5908dc6fb556895f8cd264a824c56209.svg";
export { ForwardRef as ReactComponent };